import EnvironmentLabel from './EnvironmentLabel';

export default EnvironmentLabel;
